import React, { Component } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import queryString from 'query-string';
import { useNavigate, useLocation } from 'react-router-dom'
import {Link, NavLink } from "react-router-dom";

import "./modalsmall/modal.css"
import "./css/App.css";

import "./css/tooltip.css";
import "./toasttooltip/toast.css"
import "./floating_label/style.css"

import "./tabbedcontainer/tabbedcontainer.css";
import "./menu/menu.css";
import './css/index.css';
import './css/login.css';
import './css/darken.css';
import './css/progresspiechart.css';

import './css/responsive_sections.css';
import './css/mediaresponse.css';
import './css/fontface.css';
import './comboticks/comboticks.css';
import './css/inputwithcalendicon.css';


import './autocomplete/jquery-ui.css';
import './autocomplete/jquery-ui.js';
import './modalsmall/modal.js';
//import './chartjs/baseutils.js';

//import './moment/moment.min.js';

//import "./toasttooltip/toast.js"


//import WpForm from "./components/wpform";
import WptForm from "./components/wptform";
import Startlettercaseworker from "./components/startlettercaseworker";

import Newwebuser from "./components/newwebuser";
import Wptovrrqs from "./components/wptovrrqs";
import Intairbill from "./components/intairbill";
import Imgrefseq from "./components/imgrefseq";
import Usergrp from "./components/usergrp";
import Agencycsw from "./components/agencycsw";
import Lbr_clr_letter from "./components/lbr_clr_letter";
import Paymtrcp from "./components/paymtrcp";
import Lbrclrresponse from "./components/lbrclrresponse";
import Removeapps from "./components/removeapps";
import Lcawaitapprov from "./components/lcawaitapprov";
import Chartacquisitions from "./components/chartacquisitions";


import Gvtapps from "./components/gvtapps";
import Gvtform from "./components/gvtform";
import School from "./components/school";
import Apsupdates from "./components/apsupdates";
import Scanneddocs from "./components/scanneddocs";
import Viewpdf from "./components/viewpdf";


import Adminreport from "./components/adminreport";
import Tbllbrclrrqs from "./components/tbllbrclrrqs";
import Tbllbrwkprqs from "./components/tbllbrwkprqs";
import Tbllbrdcnrqs from "./components/tbllbrdcnrqs";
import Lbr_clr_decsn_export from "./components/lbr_clr_decsn_export";


import Watchlist from "./components/watchlist";
import Agencyreg from "./components/agencyreg";
import Wptcardphoto from "./components/wptcardphoto";
import Voucher from "./components/voucher";
import Wptapprcpvchr from "./components/wptapprcpvchr";
import Fileuploadbar from "./components/fileuploadbar";


import VsaForm from "./components/vsaform";
import Startvsaapp from "./components/startvsaapp";
import Startwptapp from "./components/startwptapp";
import Wptappstoemail from "./components/wptappstoemail";

import Cancelwptapps from "./components/cancelwptapps";
import Csbundle from "./components/csbundle";
import Csbundlex from "./components/csbundlex";
import Wptprocess from "./components/wptprocess";
import Pdfdoc from "./components/pdfdoc";


import Startlcrapp from "./components/startlcrapp";
import Lbr_clr_xtl from "./components/lbr_clr_xtl";
import Intelwptapps from "./components/intelwptapps";
import Lbr_clr_app from "./components/lbr_clr_app";


import Csc from "./components/csc";
import WpApps from "./components/wpapps";
import Vsaapps from "./components/vsaapps";
import Vsastatus from "./components/vsastatus";
import Vsameeting from "./components/vsameeting";


import WpAppstest from "./components/wpappstest";
import Pmtvouchers from "./components/pmtvouchers";
import Wptappscan from "./components/wptappscan";
import Wptreports from "./components/wptreports";


import Wpusers from "./components/wpusers";
import Wpuserlogins from "./components/wpuserlogins";
import Wpvouchers from "./components/wpvouchers";
import Vsavouchers from "./components/vsavouchers";

import Wpsummary from "./components/wpsummary";
import Vsasummary from "./components/vsasummary";

import Invoices from "./components/invoices";


import Submitwpform from "./components/submitwpform";
import Submitvsaform from "./components/submitvsaform";

import Prepwpform from "./components/prepwpform";
import Exportwpform from "./components/exportwpform";


import Importwpform from "./components/importwpform";

import Webreg from "./components/webreg";
import Registrations from "./components/registrations";
import Employers from "./components/employers";
import Person from "./components/person";

import Dashboard from "./components/dashboard";

import Layout from "./components/Layout";
import NoPage from "./components/NoPage";
import Login from "./components/Login";
import Login2 from "./components/Login2";

//import Apstest from "./components/apstest";
import Myprofile from "./components/myprofile";



import $ from 'jquery'; 





class App extends Component {
  
global_instance_id;


state = {
  visible: true
  
};



  
  
  render() {
  
  
  
  
  const queryStringParams = queryString.parse(window.location.search);
//console.log('queryStringParams: '+JSON.stringify(queryStringParams));

    return (
	<>
<BrowserRouter>
      <Routes>
	  <Route path="/" element={<Layout />}>
        <Route index element={<Login />} />	  

      
      
      <Route path="wptform" element={<WptForm />} />
	  <Route path="startlettercaseworker" element={<Startlettercaseworker />} />
	  
      <Route path="newwebuser" element={<Newwebuser />} />
	  <Route path="wptovrrqs" element={<Wptovrrqs />} />
	  <Route path="intairbill" element={<Intairbill />} />
	  <Route path="imgrefseq" element={<Imgrefseq />} />
	  <Route path="usergrp" element={<Usergrp />} />
	  <Route path="agencycsw" element={<Agencycsw />} />
	  <Route path="paymtrcp" element={<Paymtrcp />} />
	  <Route path="lbrclrresponse" element={<Lbrclrresponse />} />
	  <Route path="removeapps" element={<Removeapps />} />
	  <Route path="lcawaitapprov" element={<Lcawaitapprov />} />
	  <Route path="chartacquisitions" element={<Chartacquisitions />} />
	  
	  
	  <Route path="tbllbrclrrqs" element={<Tbllbrclrrqs />} />
	  <Route path="tbllbrwkprqs" element={<Tbllbrwkprqs />} />
	  <Route path="tbllbrdcnrqs" element={<Tbllbrdcnrqs />} />
	  <Route path="lbr_clr_decsn_export" element={<Lbr_clr_decsn_export />} />
	  
	  
	  <Route path="watchlist" element={<Watchlist />} />
	  <Route path="agencyreg" element={<Agencyreg />} />
	  <Route path="wptcardphoto" element={<Wptcardphoto />} />
	  <Route path="voucher" element={<Voucher />} />
	  <Route path="wptapprcpvchr" element={<Wptapprcpvchr />} />
	  <Route path="fileuploadbar" element={<Fileuploadbar />} />


	  
	  <Route path="gvtapps" element={<Gvtapps />} />
	  <Route path="gvtform" element={<Gvtform />} />
	  <Route path="school" element={<School />} />
	  <Route path="apsupdates" element={<Apsupdates />} />
	  
	  <Route path="scanneddocs" element={<Scanneddocs />} />
	  <Route path="viewpdf" element={<Viewpdf />} />
	  
	  
	  <Route path="adminreport" element={<Adminreport />} />
	  
	  <Route path="lbr_clr_letter" element={<Lbr_clr_letter />} />
	  
	  
	  <Route path="vsaform" element={<VsaForm />} />
	  <Route path="startvsaapp" element={<Startvsaapp />} />
	  <Route path="startwptapp" element={<Startwptapp />} />
	  <Route path="wptappstoemail" element={<Wptappstoemail />} />
	  <Route path="cancelwptapps" element={<Cancelwptapps />} />
	  
	  
      <Route path="submitwpform" element={<Submitwpform />} />
      <Route path="submitvsaform" element={<Submitvsaform />} />
      <Route path="csbundle" element={<Csbundle />} />
      <Route path="csbundlex" element={<Csbundlex />} />
      <Route path="wptprocess" element={<Wptprocess />} />
      <Route path="pdfdoc" element={<Pdfdoc />} />
      
	  
      <Route path="startlcrapp" element={<Startlcrapp />} />
      <Route path="lbr_clr_xtl" element={<Lbr_clr_xtl />} />
	  <Route path="intelwptapps" element={<Intelwptapps />} />
	  
      <Route path="lbr_clr_app" element={<Lbr_clr_app />} />
	  
	  
      <Route path="prepwpform" element={<Prepwpform />} />
	  <Route path="exportwpform" element={<Exportwpform />} />
	  
	  
      <Route path="csc" element={<Csc />} />
      <Route path="wpapps" element={<WpApps />} />
      <Route path="vsaapps" element={<Vsaapps />} />
      <Route path="vsastatus" element={<Vsastatus />} />
	  <Route path="vsameeting" element={<Vsameeting />} />
	  
	  <Route path="pmtvouchers" element={<Pmtvouchers />} />
	  <Route path="wptappscan" element={<Wptappscan />} />
	  <Route path="wptreports" element={<Wptreports />} />
	  
	  
	  
      <Route path="wpusers" element={<Wpusers />} />
      <Route path="wpuserlogins" element={<Wpuserlogins />} />
      <Route path="wpvouchers" element={<Wpvouchers />} />
      <Route path="vsavouchers" element={<Vsavouchers />} />
	  <Route path="wpsummary" element={<Wpsummary />} />
	  <Route path="vsasummary" element={<Vsasummary />} />
	  
	  <Route path="invoices" element={<Invoices />} />
	  <Route path="myprofile" element={<Myprofile />} />

      <Route path="importwpform" element={<Importwpform />} />
	  
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="employers" element={<Employers />} />
      <Route path="person" element={<Person />} />
      <Route path="registrations" element={<Registrations />} />
      <Route path="webreg" element={<Webreg />} />
	  
      {/*<Route path="apstest" element={<Apstest />} />*/}
	  <Route path="login" element={<Login />} />
		<Route path="login2" element={<Login2 />} />
	  
	  
	<Route path="*" element={<Login />} />

      </Route>
      </Routes>
</BrowserRouter>
		  </>


    );
  }
}

export default App;
